export const ALLOWED_ATTACHMENTS =
  'application/msword,' + // doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' + // docx
  'application/pdf,' + // pdf
  'application/vnd.openxmlformats-officedocument.presentationml.presentation,' + // pptx
  'application/rtf,' + // rtf
  'application/vnd.ms-excel,' + // xsl
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // xslx
